import { ProductPagePaths } from "@faire/deprecated-retailer-visitor-shared/paths/ProductPage";
import { BrandPageQueryObj } from "@faire/retailer-shared/search/BrandPageQueryObj";
import { getLocationOrThrow } from "@faire/web/common/globals/getLocation";
import { isPrerender } from "@faire/web/common/user-agent/isPrerender";
import qs from "query-string";

export const generateProductUrlForBrandPage = (
  productToken: string,
  productOptionToken?: string,
  showSideCart?: boolean
): string => {
  const { cat, sortBy, q, sortingHint, page, refS, refC, refF, refP } =
    qs.parse(getLocationOrThrow().search) as BrandPageQueryObj;

  if (isPrerender()) {
    return ProductPagePaths.index(productToken);
  }
  // see BrandProducts#fetchProducts
  return ProductPagePaths.index(productToken, {
    refB: "1",
    bCat: cat,
    bSortBy: sortBy,
    bQ: q,
    bSortingHint: sortingHint,
    bPage: page,
    bRefS: refS,
    bRefC: refC,
    bRefF: refF,
    bRefP: refP,
    productOptionToken: productOptionToken,
    ...(showSideCart && { showSideCart: "1" }),
  });
};
